import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'trending-up-2', 'IconTrendingUp2', [["path",{"d":"M18 5l3 3l-3 3","key":"svg-0"}],["path",{"d":"M3 18h5l7 -10h6","key":"svg-1"}]]);